export const monsterTypesByGender: any = {
	male: {
		types: ['celestial', 'dragon', 'elemental', 'giant', 'humanoid', 'monstrosity'],
		sizes: {
			Gargantuan: 'Исполинский',
			Huge: 'Огромный',
			Large: 'Крупный',
			Medium: 'Средний',
			Small: 'Небольшой',
			Tiny: 'Маленький',
		},
		alignments: {
			N: 'Нейтральный',
			E: 'Злой',
			L: 'Принципиальный',
			C: 'Хаотичный',
			G: 'Добрый',
			U: 'без мировоззрения',
		},
	},
	female: {
		types: ['aberration', 'construct', 'fey', 'fiend', 'ooze', 'undead'],
		sizes: {
			Gargantuan: 'Исполинская',
			Huge: 'Огромная',
			Large: 'Крупная',
			Medium: 'Средняя',
			Small: 'Небольшая',
			Tiny: 'Маленькая',
		},
		alignments: {
			N: 'Нейтральная',
			E: 'Злая',
			L: 'Принципиальная',
			C: 'Хаотичная',
			G: 'Добрая',
			U: 'без мировоззрения',
		},
	},
	neutral: {
		types: ['beast', 'plant'],
		sizes: {
			Gargantuan: 'Исполинское',
			Huge: 'Огромное',
			Large: 'Крупное',
			Medium: 'Среднее',
			Small: 'Небольшое',
			Tiny: 'Маленькое',
		},
		alignments: {
			N: 'Нейтральное',
			E: 'Злое',
			L: 'Принципиальное',
			C: 'Хаотичное',
			G: 'Доброе',
			U: 'без мировоззрения',
		},
	},
	plural: {
		sizes: {
			Gargantuan: 'Исполинские',
			Huge: 'Огромные',
			Large: 'Крупные',
			Medium: 'Средние',
			Small: 'Небольшие',
			Tiny: 'Маленькие',
		},
		alignments: {
			N: 'Нейтральные',
			E: 'Злые',
			L: 'Принципиальные',
			C: 'Хаотичные',
			G: 'Добрые',
			U: 'без мировоззрения',
		},
	},
};
